<template>
     <!-- <ul> 和 <li> 是 HTML 中用来创建无序列表（unordered list）的标签。
<ul>（unordered list）：表示一个无序列表。这个标签通常包含一个或多个 <li> 元素，它会自动为每个 <li> 项目前添加一个圆点或标记。
<li>（list item）：表示列表中的一个项目。每个 <li> 标签通常会包含具体的内容，例如文本、图片等。在 <ul> 标签内，多个 <li> 标签表示列表的不同项。

作用：
<ul>：创建一个无序的、项目信息列出结构。这个标签包裹所有的 <li> 项目。
<li>：定义列表的每一项。每个 <li> 元素表示列表中的一个独立项目。 -->
    <div class="process w" @mouseenter="stopTimer" @mouseleave="startTimer"><!-- 🟥 给最外层div加上鼠标移入移出事件 APP应用  Tap应用自动切换和鼠标选择-->
        
        <div class="title"><router-link to="/allGameViewVue">应用推荐 </router-link><!-- APP应用  Tap应用 -->

            <!-- 🟥改动：文字改为可点击切换标签 -->
             <span class="tab-text" :class="{active: tab === 'app'}" @click="tab = 'app'">APP游戏</span>
             <span class="tab-text" :class="{active: tab === 'tap'}" @click="tab = 'tap'">AI游戏</span>

            <router-link to="/allGameViewVue">查看所有应用></router-link>
            <!-- <a href="">查看所有游戏></a> -->
        </div>
        <!-- <div class="text">Few Step For a New Home</div> -->
        <div class="process-img">
            <ul>
                <!-- 🟥改动：删除手写死的li，用v-for循环渲染 -->
                <li v-for="item in showGameList" :key="item.route">
                    <router-link :to="item.route">
                        <img :src="item.img" alt="">
                    </router-link>
                    <p class="step">
                        <router-link :to="item.route">{{ item.name }}</router-link>
                    </p>
                </li>
                <!-- 魔幻轮回 图片 -->
                <!-- <li>
                    <router-link to="/oneGameViewVue">
                        <img src="@/assets/img/MHLH/icon1-512.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/oneGameViewVue">魔幻轮回</router-link> 
                    </p>
                </li> -->
                <!-- 魔卡契约 图片 -->
                <!-- <li>
                    <router-link to="/mkqy02GameVue">
                        <img src="@/assets/img/02MKQY/216.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/mkqy02GameVue">魔卡契约</router-link> 
                    </p>
                </li>
                <li>
                    <router-link to="/fzwlqx03GameVue">
                        <img src="@/assets/img/FZWLQX/1.png" alt="">
                    </router-link>
                    <p class="step">
                        <router-link to="/fzwlqx03GameVue">放置：蔚蓝前线</router-link> 
                    </p>
                </li> -->



                <!-- <li>
                    <img src="@/assets/img/20250213204801.png" alt="">
                    <p class="step">step1 选择宠物</p>
                </li>
                <li>
                    <img src="@/assets/img/20250213204801.png" alt="">
                    <p class="step">step1 选择宠物</p>
                </li>
                <li>
                    <img src="@/assets/img/20250213204801.png" alt="">
                    <p class="step">step1 选择宠物</p>
                </li> -->
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    // 🟩新增props，接收父页面传来的数据
  props: {
    appList: Array,
    tapList: Array
  },
  data () {
    return {
        tab: "app", // 默认显示APP应用
        timer: null // 🟩定义定时器容器
    }
  },
  // 🟩计算属性：根据tab切换展示对应数组
  computed: {
    showGameList() {
      return this.tab === "app" ? this.appList : this.tapList
    }
  },
  methods: {
    // 🟩开启自动切换
    startTimer() {
      this.timer = setInterval(() => {
        this.tab = this.tab === "app" ? "tap" : "app"
      }, 2000) // 3000毫秒=3秒切换一次，自行修改数字
    },
    // 🟩停止自动切换
    stopTimer() {
      clearInterval(this.timer)
    }
  },
  mounted() {
    // 🟩页面加载立刻启动轮播
    this.startTimer()
  },
  beforeDestroy() {
    // 🟩页面销毁清空定时器，防止内存溢出
    clearInterval(this.timer)
  },
}
</script>
<style scoped>
.process-img ul {
    display: flex;
    justify-content: center;   /* 整体居中 */
    gap: 100px;                 /* 两个图片之间的间隔 */
    flex-wrap: wrap;   /* 自动换行 */
    padding: 0;
    margin: 0;
    list-style: none;
}
.title > a:first-child,
.title > a:first-child:visited {
  color: #000;        /* 黑色字体 */
  font-size: 28px;    /* 字体变大 */
  font-weight: 600;   /* 可选：稍微加粗 */
}

/* 🟪新增切换文字选中样式  */
.tab-text {
  margin: 0 10px;
  cursor: pointer;
  padding: 3px 8px;
  font-size: 16px;
}
.tab-text.active {
  background-color: #276de8;
  color: #fff;
  border-radius: 4px;
}
.process {
  margin-top: 5px; /* 数值自己调，20/30/40/50 按需改大小 */ 
}


</style>
